import { useEffect, useState } from "react";
import heroImage from "../../assets/jag2.jpg";
import avatar from "../../assets/favicon.svg";
import "./Greeting.css";

function FloatingContactBadge() {
  return (
    <a
      className="floating-badge"
      href="mailto:wilma.edman@gmail.com?subject=Hello%20Wilma!"
      aria-label="Email Wilma"
    >
      <svg className="floating-ring" viewBox="0 0 200 200" aria-hidden="true">
        <defs>
          <path
            id="circlePath"
            d="M 100,100
               m -78,0
               a 78,78 0 1,1 156,0
               a 78,78 0 1,1 -156,0"
          />
        </defs>

        <text
            className="floating-ring-text"
            textLength="490"
            lengthAdjust="spacingAndGlyphs"
          >
            <textPath href="#circlePath">
              contact • me • contact • me • contact • me • contact • me •
            </textPath>
        </text>

      </svg>

      <img className="floating-avatar" src={avatar} alt="Wilma" />
    </a>
  );
}

export default function Greeting() {
  const fullText = "Hello my name is Wilma";
  const [text, setText] = useState("");
  const [i, setI] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  useEffect(() => {
    const speed = isDeleting ? 40 : 80;

    const timeout = setTimeout(() => {
      if (!isDeleting && i < fullText.length) {
        setText(fullText.slice(0, i + 1));
        setI(i + 1);
      } else if (!isDeleting) {
        setTimeout(() => setIsDeleting(true), 1200);
      } else if (i > 0) {
        setText(fullText.slice(0, i - 1));
        setI(i - 1);
      } else {
        setIsDeleting(false);
      }
    }, speed);

    return () => clearTimeout(timeout);
  }, [i, isDeleting]);

  return (
    <section className="hero">
      <div className="hero-inner">
        <div className="grid-container">
          <div className="text-area">
            <div>
              <h1 className="hero-title">
                <span className="typing-line">
                  {text}
                  <span className="typing-cursor">|</span>
                </span>

                <span className="hero-subline">A digital designer</span>
                <span className="hero-subline">
                  based in <span className="sweden-text">Sweden.</span>
                </span>
              </h1>

              <p className="hero-desc">
                Who loves creating thoughtful and creative design.
              </p>
            </div>
          </div>

          <div className="image-area">
            <img src={heroImage} alt="Wilma" />
          </div>
        </div>
      </div>

      <div
        className="scroll-down"
        onClick={() =>
          window.scrollTo({ top: window.innerHeight, behavior: "smooth" })
        }
      >
        <i className="fa-solid fa-chevron-down"></i>
      </div>

      <FloatingContactBadge />
    </section>
  );
}




